/**
 * Storage keys
 */
export const STORAGE_KEYS = {
  CART: "fs_cart",
  EVENT_QUEUE: "fs_event_queue",
  SERVER_SETTINGS: "fs_server_settings",
  SETTINGS_OVERRIDE: "fs_settings_override",
  ATTRIBUTION_CACHE: "fs_attribution_cache",
  AUTHENTICATED_USER: "fs_authenticated_user",
} as const;

/**
 * Cookie keys
 */
export const COOKIE_KEYS = {
  LOCALE: "fluid_locale",
  COUNTRY: "fluid_country",
  LANGUAGE: "fluid_language",
  JOURNEY: "fluid_journey",
  JOURNEY_SYNCED: "fluid_journey_synced",
  AFFILIATE: "fluid_affiliate",
  SESSION: "fluid_session",
  AUTHENTICATED_JWT: "fluid_authenticated_jwt",
  AUTHENTICATED_AT: "fluid_authenticated_at",
} as const;
